import { forEach } from 'lodash';
import { apiClient, apiErrorHandler, ADMIN_URL } from 'src/app/common/network';
import { getDayEnd } from 'src/app/common/utils';
import { Dispatch } from 'react';
import { BULK_UPLOAD_TYPE } from '../types/bulk-upload-types';
import { getError } from '../comm';

const bulkUploadEndpoint = '/pruwallet/admin';

export type BulkUploadListParam = {
  fileName?: string;
  operationType?: BULK_UPLOAD_TYPE;
  dateFrom?: Date | null;
  dateTo?: Date | null;
  page: number;
  pageSize: number;
};

export type CheckInvalidCampaignParam = {
  campaignIdList: string[];
  validStatusList: string[];
};

export type BulkUploadFailedListParam = {
  page: number;
  limit: number;
};

export type CreateBulkUploadFileBody = {
  resourceId?: string;
  type?: string;
  filename?: string;
  scheduledUploadTime?: Date | null;
};

export const fetchBulkUploadStatusList = async (params: BulkUploadListParam, dispatch?: Dispatch<any>) => {
  let queryPath = `${ADMIN_URL}${bulkUploadEndpoint}/bulk-operations?`;
  forEach(params, (param, key) => {
    if (typeof param === 'object') {
      if (param) {
        if (key.toLowerCase().includes('from')) {
          queryPath += `${key}=${encodeURIComponent(getDayEnd(param).toISOString().split('T')[0])}&`;
        }
        if (key.toLowerCase().includes('to')) {
          queryPath += `${key}=${encodeURIComponent(getDayEnd(param).toISOString().split('T')[0])}&`;
        }
      }
    } else {
      if (key === 'page') {
        queryPath += `${key}=${encodeURIComponent(param as any)}&`;
      } else {
        queryPath += param ? `${key}=${encodeURIComponent(param as any)}&` : '';
      }
    }
  });
  return apiClient
    .get(queryPath)
    .then((response) => {
      const { items, totalPages, totalCount, pageSize, page } = response?.data?.data;
      const result = {
        totalPages,
        page,
        limit: pageSize,
        docs: items,
        pagingCounter: totalPages,
        totalDocs: totalCount,
      };
      return result;
    })
    .catch((err) => {
      throw apiErrorHandler(getError(err), dispatch);
    });
};

export const fetchBulkUploadAwardFailedList = async (id: string, dispatch?: Dispatch<any>) => {
  let queryPath = `${ADMIN_URL}${bulkUploadEndpoint}/award/promo-codes/bulk-operations/${id}`;

  return apiClient
    .get(queryPath)
    .then((response) => {
      const details = response.data?.data?.errorDetails ?? {};
      const arr = Object.entries(details)
        .sort((a, b) => Number(a[0].split('_')[1]) - Number(b[0].split('_')[1]))
        .map(([key, val]) => ({
          row: Number(key.split('_')[1]),
          ...(val as Record<string, unknown>),
        }));
      return arr;
    })
    .catch((err) => {
      throw apiErrorHandler(getError(err), dispatch);
    });
};

export const fetchBulkUploadCreditFailedList = async (id: string, dispatch?: Dispatch<any>) => {
  let queryPath = `${ADMIN_URL}${bulkUploadEndpoint}/credits/bulk-operations/${id}`;
  return apiClient
    .get(queryPath)
    .then((response) => {
      const details = response.data?.data?.errorDetails ?? {};
      const arr = Object.entries(details)
        .sort((a, b) => Number(a[0].split('_')[1]) - Number(b[0].split('_')[1]))
        .map(([key, val]) => ({
          row: Number(key.split('_')[1]),
          ...(val as Record<string, unknown>),
        }));
      return arr;
    })
    .catch((err) => {
      throw apiErrorHandler(getError(err), dispatch);
    });
};
